const promises = {};
export function injectScript(id, url) {
  let async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let defer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (document.getElementById(id)) {
    return Promise.resolve();
  }
  // reuse running promise avoiding script duplication
  if (id in promises) {
    return promises[id];
  }

  // inject tag and attach on load func then resolve
  promises[id] = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = url;
    script.async = async;
    script.defer = defer;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', reject);
    document.head.appendChild(script);
  });
  return promises[id];
}